// Immersives behavior
import "../css/immersive.css";

// get common elements
const navbar = document.querySelector("#top-nav");
const livebanner = document.querySelector("#livenow-banner");

// open an immersive
const immerse = (el) => {
  // position and open the immersive
  if (el) {
    el.style.maxHeight = el.scrollHeight + "px";
    el.classList.add("open");
    el.classList.remove("closed");
    gtag("event", "immersive_open", {
      immersive_name: el.classList[0],
    });
  }

  // hide the navigation bar and livebanner
  navbar && navbar.classList.add("hidden");
  livebanner && livebanner.classList.add("hidden");
};

// manage navbar visibility
let lastScrollPosition = window.scrollY;
let scrolled = false;
setInterval(function () {
  if (scrolled) {
    checkScrollPosition();
    scrolled = false;
  }
}, 250);
const checkScrollPosition = () => {
  if (window.scrollY < lastScrollPosition || window.scrollY < 20) {
    navbar && navbar.classList.remove("hidden");
  } else {
    for (let el of document.getElementsByClassName("immersive")) {
      if (el.classList.contains("open")) {
        document.getElementById("top-nav").classList.add("hidden");
      }
    }
  }
  lastScrollPosition = window.scrollY;
};
window.addEventListener("scroll", () => {
  scrolled = true;
});

// update maxHeight adjustments to open immersives
window.addEventListener("resize", () => {
  document.querySelectorAll(".immersive.open").forEach((el) => {
    el.style.maxHeight = el.scrollHeight + "px";
  });
});

const ready = (callback) => {
  if (document.readyState != "loading") callback();
  else document.addEventListener("DOMContentLoaded", callback);
};
ready(() => {
  // launch immersives from a URL hash
  const immerseFromHash = (hash) => {
    immerse(document.getElementById(hash.substr(1)));
  };
  if (window.location.hash) {
    immerseFromHash(window.location.hash);
  }
  window.addEventListener("hashchange", (event) => {
    immerseFromHash(window.location.hash);
  });

  // launch immersives from a click
  document.querySelectorAll(".intro").forEach((el) => {
    el.addEventListener(
      "click",
      (event) => {
        immerse(el.parentElement);
      },
      true
    );
  });
});
